// TODO: The notification system is not ported yet.

import "@babel/polyfill";

import {createBrowserHistory} from 'history';
import {configureStore} from './frontend/app/store';
import {AppContainer} from 'react-hot-loader'
import {IntlProvider, addLocaleData} from 'react-intl';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import routes from './routes/frontend';
import React from 'react';
import ReactDOM from 'react-dom';
import when from 'when';
import * as Sentry from '@sentry/browser';
import {clearNotifications} from './frontend/app/notifications.js';

import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import es from 'react-intl/locale-data/es';
import fr from 'react-intl/locale-data/fr';
import it from 'react-intl/locale-data/it';
import nl from 'react-intl/locale-data/nl';

/* global global */
const root = window || global;

Sentry.init({
    dsn: window.SENTRY_DSN,
    releaase: window.RELEASE,
    tracesSampleRate: 1.0,
});

// Require core stylesheet to load via webpack
require('../stylesheets/core.scss');
require('../stylesheets/fontawesome.scss');

// As long as we run under /beta we need this mumbo jumbo.
// Can be replaced by: import { browserHistory } from 'react-router-dom';
const history = createBrowserHistory({
    basename: '/',
});

// All things related to setting up the Redux store can be found in core/store
// If you need to edit reducers, reducers/index is the place to look. All
// the reducers are hooked up there, not in core/store.
const store = configureStore(history, window.INITIAL_STATE || {});

if (window && __DEV__) {
    window.React = React; // enable debugger
    window.store = store;
}

addLocaleData([...en, ...de, ...es, ...fr, ...it, ...nl]);

history.listen(() => {
    // NOTE
    // Do not dispatch any redux actions inside this listener.
    // Otherwise infinite redirect loops may occur.
});

function loadLocaleData(locale) {
    // TODO: This is the right place to implement lazy fetching of additional
    // locales (e. g. when the user changes the locale via the frontend).
    // Right now we only support the server-side rendering of locales
    if (!window || !window.LOCALES || !window.LOCALES[locale]) {
        return when.reject(new Error(`Locale "${locale}" is not loaded`));
    }

    return when.resolve(window.LOCALES[locale].messages);
}

function run() {
    let ErrorBoundary = null;

    function getCookie(name) {
        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    if (!window.location.pathname.startsWith('/auth') && !window.location.pathname.startsWith('/select')) {
        if (window.location.hash.startsWith('#/admin')) {
            window.location.href = '/classic/' + window.location.hash;
            return;
        }
    }

    const locale = document.documentElement.getAttribute('lang');
    loadLocaleData(locale).then(messages => {
        ReactDOM.render(
            <AppContainer>
                <IntlProvider locale={locale} messages={messages}>
                    <Provider store={store}>
                        <ConnectedRouter history={history}>
                            {
                                ErrorBoundary !== null
                                    ? (<ErrorBoundary>{routes}</ErrorBoundary>)
                                    : (<div>{routes}</div>)
                            }
                        </ConnectedRouter>
                    </Provider>
                </IntlProvider>
            </AppContainer>,
            document.getElementById('react-app')
        );
    }).catch(e => {
        throw e;
    });

    // React hot loader
    if (module.hot && process.env.NODE_ENV === 'development') {
        module.hot.accept();
    }

}

if (root && root.Intl) {
    run();
} else {
    require.ensure(['intl'], run);
}

// Return falsy value instead of throwing an error (do not report parsing errors to bugsnag).
const oldParse = JSON.parse;
JSON.parse = function (string) {
    try {
        return  oldParse(string);
    } catch (e) {
        return null;
    }
};
